import { useFetch as useFetchMumble } from '@mumble/hooks'
import useUser from '@/js/hooks/useUser'
import { UseFetchOptions } from '@mumble/hooks/vue/useFetch'
import { QueryKey } from '@tanstack/vue-query'

export default function useFetch(key: QueryKey, api: () => Promise<any>, options?: UseFetchOptions) {
    const { user } = useUser()

    return useFetchMumble(key, api, {
        ...options,
        logOptions: {
            user: user.value,
            type: 'api',
        },
    })
}
